export default __webpack_public_path__ + "static/media/learning_space.816bf6ff.png";